import * as React from "react"

const CheckBox = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63.06 43.08" {...props}>
    <title>{"parcel-journey-1-check-box-icon-2"}</title>
    <path
      d="M35.13 8.44v30.91H3.73V8.44h31.4m3.72-3.74H0v38.38h38.85Z"
      fill="#4ead90"
    />
    <path
      fill="#fff"
      d="m33.49 21.28-2.14 2.14v10.84h3.36l12.84-12.98H33.49z"
    />
    <path
      fill="#4ead90"
      d="M28.6 34.91 7.22 13.52 20.96 13l7.64 7.64L49.24 0l13.82.09L28.6 34.91z"
    />
  </svg>
)

export default CheckBox
